import Flickity from 'flickity';

class imageSlider {
	constructor(config) {
		this.config = Object.assign({
			scope: '.image_slider'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((it, scope) => {
			let $scope = $(scope);
			let $slider = $scope.find('.flickity-carousel');
			let slider = Flickity.data($slider[0]);

			// Set page dots
			this.setPageDots(slider, $scope)
			// Change page dot amount on resize
			$(window).resize(() => {
				// Only execute function when resizing stops
				this.timeout ? clearTimeout(this.timeout) : '';
				this.timeout = setTimeout(() => {
					this.setPageDots(slider, $scope)
				}, 300);
			});

			slider.on('change', index => this.changeSelectedDot(index, $scope));

			$scope.on('click', '.custom-flickity-dot', (e) => {
				e.preventDefault();
				let $button = $(e.currentTarget);
				this.setCurrentSlide(slider, $button);
			})
		});
	}

	setPageDots(slider, $scope) {
		let $pageDot = $('<a href="#" class="d-block bg-secondary flex-grow-1 custom-flickity-dot"></a>');
		let $wrapper = $scope.find('.custom-flickity-dots');
		let amount = slider.slides.length;

		$wrapper.html('');
		for(let i = 0; i <= (amount - 1); i++) {
			let $dot = $pageDot.clone();
			$dot.attr('data-index', i);

			if(slider.selectedIndex === i) {
				$dot.addClass('is-selected')
			}

			$wrapper.append($dot);
		}
	}

	changeSelectedDot(index, $scope) {
		$scope.find('.custom-flickity-dot').removeClass('is-selected');
		$scope.find(`.custom-flickity-dot[data-index=${index}]`).addClass('is-selected');
	}

	setCurrentSlide(slider, $button) {
		slider.select($button.data('index'));
	}
}

export default new imageSlider;